/*
 * ===============================================================================================================
 *                                Copyright 2021, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
export const ADD_ROLE_MAPPING = "Add Role Mapping";
export const EDIT_ROLE_MAPPING = "Edit Role Mapping";
export const ROLE_MAPPING_MESSAGE = "Make sure the identity provider role name matches exactly with what is in the identity provider directory (e.g. Active Directory).";
export const TITLE = 'accessing Roles';
export const LOCAL_ROLE_DROP_DOWN_HELPER_TEXT = "Roles added via the Roles tab";
export const ROLE_NAME_HELPER_TEXT = "Role name must match exactly";
export const IDENTITY_PROVIDER_REQUIRED = 'Identity Provider is required';
export const ROLE_NAME_IDENTITY_PROVIDER_REQUIRED = 'Identity Provider Role Name is required';
export const LOCAL_ROLE_NAME_REQUIRED = 'Blue Yonder Role Name is required';
export const ROLE_MAPPING_CREATED_SUCCESSFULLY = 'Role Mapping "{0}" created successfully';
export const ROLE_MAPPING_UPDATED_SUCCESSFULLY = 'Role Mapping "{0}" updated successfully';
export const ROLE_MAPPING_CREATION_FAILED = 'Error in creating role mapping: {0}';
export const ROLE_MAPPING_UPDATION_FAILED = 'Error in updating role mapping: {0}';
export const SAVE_BTN_TEXT = 'Save';
export const CANCEL_BTN_TEXT = 'Cancel';
